import type { CSSProperties } from 'react';

export const MENU_DROPDOWN_WIDTH = '240px';

export const getCaretStyle = (isOpen: boolean): CSSProperties => ({
  display: 'inherit',
  transform: isOpen ? 'rotate(180deg)' : undefined,
  transition: 'transform 150ms ease',
});
